var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 25.334c0-2.689 2.93-5.38 8.088-5.333 5.158.047 7.912 3.007 7.912 5.333 0 2.598-5.085 2.598-7.912 2.667-2.827.068-8.088-.069-8.088-2.667zm28.243-19.92l2.828-2.828A2 2 0 1 1 53.9 5.414l-2.828 2.829L53.9 11.07a2 2 0 1 1-2.828 2.828l-2.828-2.828-2.829 2.828a2 2 0 0 1-2.828-2.828l2.828-2.828-2.828-2.829a2 2 0 0 1 2.828-2.828l2.829 2.828zm-40 0l2.828-2.828A2 2 0 1 1 13.9 5.414l-2.828 2.829L13.9 11.07a2 2 0 1 1-2.828 2.828L8.244 11.07l-2.83 2.83a2 2 0 1 1-2.828-2.828l2.828-2.828-2.828-2.829a2 2 0 1 1 2.828-2.828l2.829 2.828z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F1",
    cx: 57,
    cy: 57,
    r: 57
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 45)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#425175",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5873B5",
    d: "M0 0h56v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.35,
    fill: "#000",
    fillRule: "nonzero",
    d: "M0 0h56v30H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M31.023 61.63c2.978 1.453 4.804 3.838 4.078 5.327-.727 1.489-3.73 1.519-6.708.066-2.979-1.453-4.804-3.837-4.078-5.327.726-1.489 3.73-1.518 6.708-.066zm56 5.393c-2.978 1.453-5.982 1.423-6.708-.066-.726-1.49 1.1-3.874 4.078-5.327 2.978-1.452 5.981-1.423 6.708.066.726 1.49-1.1 3.874-4.078 5.327z",
    fill: "#FDCFCD",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilter);
export default __webpack_public_path__ + "static/media/empty-filter.90a4eb4446518a7f707a02415c4c3f4e.svg";
export { ForwardRef as ReactComponent };